<template>
	<div
    v-if="!['DiloConNieve', 'Subscriptions'].includes(active_route)"
    class="search-container"
  >
		<div :class="`input-container ${active_route == 'DetailFlavor' ? 'input-container-detail-product' : 'input-container-all'}`">
			<input
        placeholder="Busca un producto"
        class="input-global-search"
        v-model="search"
        @keyup.enter="executeSearch()"
      >
      <v-icon
        style="cursor:pointer"
        large
        color="light"
        @click="executeSearch()"
      >
        mdi-magnify
      </v-icon>
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      search: '',
    }
  },
  computed: {
    active_route() {
      return this.$route.name
    },
  },
  methods: {
    executeSearch() {
      if (this.search) {
        this.$router.push({
          path: '/productos-busqueda',
          query: { q: this.search }
        })
      }
    }
  }
}
</script>

<style scoped>
	.search-container {
		position: relative;
		z-index: 7;
		width: 100%;
  }
  .input-container {
    position: absolute;
		right: 3%;
		margin-top: 1.5em;
		width: 350px;
    transition: all 0.3s;
  }
  .expand {
    width: 350px;
  }
	.input-container-all {
		margin-top: 1.5em;
  }
  .input-container-detail-product {
		margin-top: -20px;
	}
	.input-global-search {
		width: 100%;
		background-color: rgba(251, 183, 196, 0.6);
		color: white;
		border-radius: 15px;
		padding: 3px;
		font-family: var(--font-baloo-regular) !important;
    font-size: 20px;

	}
	.input-global-search:focus{
		color: white;
    outline: none !important;
	}
	.input-global-search::placeholder {
    color: white;
    padding-left: 10%;
  }
  .v-icon.v-icon {
    position: absolute;
    top: 2px;
    right: 15px
  }
  @media (max-width: 499px) {
    .input-container-all, .input-container-detail-product {
      margin-top: 5%;
    }
    .input-container {
      right: 3%;
    }
    .input-global-search {
      width: 100%;
      font-size: 18px;
    }
    .v-icon.v-icon {
      top: -1px;
      right: 5%
    }
  }
  @media (max-width: 375px) {
    .input-container-all, .input-container-detail-product {
      margin-top: 5%;
    }
    .input-container {
      right: 1%;
    }
  }
</style>
